(function () {
  if (window.__dreoBenefitsModalLoaded) return;
  window.__dreoBenefitsModalLoaded = true;

  const DEFAULT_MODAL_ID = 'benefits-modal';
  let activeModalId = null;

  // 阻止页面滚动函数
  function preventPageScroll(e) {
    if (!activeModalId) return;
    const modal = document.getElementById(activeModalId);
    if (!modal || modal.style.display !== 'flex') {
      return;
    }

    // 检查是否是弹窗内容区域的滚动
    const modalContent = modal.querySelector('.benefits-modal__content');
    const accordion = modal.querySelector('.benefits-modal__accordion');

    // 如果是弹窗内容或手风琴区域的滚动，允许
    if (modalContent && modalContent.contains(e.target)) {
      return;
    }
    if (accordion && accordion.contains(e.target)) {
      return;
    }

    // 所有其他情况都阻止页面滚动
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  function openBenefitsModal(activeIndex, modalId) {
    modalId = modalId || DEFAULT_MODAL_ID;
    const modal = document.getElementById(modalId);
    if (!modal) return;

    // 将弹窗移动到body的最后面，避免层叠上下文问题
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    // 强制设置样式确保弹窗显示在最顶层
    modal.style.cssText = `
      display: flex !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
      z-index: 2147483647 !important;
      background: rgba(0, 0, 0, 0.7) !important;
      justify-content: center !important;
      align-items: center !important;
      box-sizing: border-box !important;
      isolation: isolate !important;
      transform: translateZ(0) !important;
      pointer-events: auto !important;
    `;

    // 确保弹窗内容也有正确的z-index和样式
    const modalContent = modal.querySelector('.benefits-modal__content');
    if (modalContent) {
      // 检测设备类型
      const isMobile = window.innerWidth <= 767;
      const isIPadMini = window.innerWidth === 768;

      if (isMobile) {
        modalContent.style.cssText = `
          background: #ffffff !important;
          border-radius: 12px !important;
          box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15) !important;
          position: relative !important;
          z-index: 2147483647 !important;
          max-height: 90vh !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 0 !important;
          padding: 0 !important;
          width: 100vw !important;
          max-width: 100vw !important;
          isolation: isolate !important;
          transform: translateZ(0) !important;
          pointer-events: auto !important;
          box-sizing: border-box !important;
        `;

        // 移动端特殊处理
        modal.style.alignItems = 'flex-end !important';
        modal.style.padding = '0 !important';
        modal.style.overflowX = 'hidden !important';
      } else if (isIPadMini) {
        modalContent.style.cssText = `
          background: #ffffff !important;
          border-radius: 16px !important;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
          position: relative !important;
          z-index: 2147483647 !important;
          max-height: 100% !important;
          overflow-y: auto !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 24px !important;
          padding: 24px 20px 40px !important;
          width: calc(100vw - 32px) !important;
          max-width: calc(100vw - 32px) !important;
          isolation: isolate !important;
          transform: translateZ(0) !important;
          pointer-events: auto !important;
        `;
      } else {
        modalContent.style.cssText = `
          background: #ffffff !important;
          border-radius: 16px !important;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
          position: relative !important;
          z-index: 2147483647 !important;
          max-height: 100% !important;
          overflow-y: auto !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 24px !important;
          padding: 24px 32px 40px !important;
          width: 752px !important;
          max-width: calc(100vw - 48px) !important;
          isolation: isolate !important;
          transform: translateZ(0) !important;
          pointer-events: auto !important;
        `;
      }
    }

    // 确保弹窗的所有子元素都有正确的样式
    const isCurrentMobile = window.innerWidth <= 767;
    const isCurrentIPadMini = window.innerWidth === 768;

    // 处理弹窗头部
    const modalHeader = modal.querySelector('.benefits-modal__header');
    if (modalHeader) {
      if (isCurrentMobile) {
        modalHeader.style.cssText = `
          background: #ffffff !important;
          border-radius: 12px 12px 0 0 !important;
          padding: 30px 24px !important;
          gap: 0 !important;
          justify-content: space-between !important;
          height: auto !important;
          min-height: 78px !important;
          box-sizing: border-box !important;
          margin: 0 !important;
          flex-shrink: 0 !important;
          display: flex !important;
          align-items: center !important;
        `;
      } else if (isCurrentIPadMini) {
        modalHeader.style.cssText = `
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 50px !important;
          margin: 0 !important;
          padding: 0 !important;
        `;
      } else {
        modalHeader.style.cssText = `
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          gap: 50px !important;
          margin: 0 !important;
          padding: 0 !important;
        `;
      }
    }

    // 处理分隔线
    const modalSeparator = modal.querySelector('.benefits-modal__separator');
    if (modalSeparator) {
      if (isCurrentMobile) {
        modalSeparator.style.cssText = `
           width: calc(100vw - 40px) !important;
           margin: 0 20px !important;
           flex-shrink: 0 !important;
           height: 1px !important;
           background-color: #E2E2E2 !important;
         `;
      } else if (isCurrentIPadMini) {
        modalSeparator.style.cssText = `
          width: calc(100vw - 72px) !important;
          height: 1px !important;
          background-color: #E2E2E2 !important;
          margin: 0 !important;
        `;
      } else {
        modalSeparator.style.cssText = `
          width: 688px !important;
          height: 1px !important;
          background-color: #E2E2E2 !important;
          margin: 0 !important;
        `;
      }
    }

    // 处理手风琴区域
    const modalAccordion = modal.querySelector('.benefits-modal__accordion');
    if (modalAccordion) {
      if (isCurrentMobile) {
        modalAccordion.style.cssText = `
           padding: 24px 24px 30px !important;
           gap: 11px !important;
           width: 100% !important;
           max-width: 100% !important;
           overflow-y: auto !important;
           overflow-x: hidden !important;
           flex: 1 !important;
           min-height: 0 !important;
           display: flex !important;
           flex-direction: column !important;
           box-sizing: border-box !important;
         `;
      } else if (isCurrentIPadMini) {
        modalAccordion.style.cssText = `
          display: flex !important;
          flex-direction: column !important;
          gap: 16px !important;
          width: calc(100vw - 72px) !important;
        `;
      } else {
        modalAccordion.style.cssText = `
          display: flex !important;
          flex-direction: column !important;
          gap: 16px !important;
          width: 688px !important;
        `;
      }
    }

    // 为移动端设置手风琴项目和文本的样式
    if (isCurrentMobile) {
      const accordionItems = modal.querySelectorAll('.benefits-accordion__item');
      accordionItems.forEach((item) => {
        item.style.cssText = `
          gap: 11px !important;
          width: 100% !important;
          max-width: 100% !important;
          position: relative !important;
          box-sizing: border-box !important;
        `;
      });

      const accordionTitles = modal.querySelectorAll('.benefits-accordion__title');
      accordionTitles.forEach((title) => {
        title.style.cssText = `
          font-size: 14px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          width: auto !important;
          max-width: calc(100vw - 120px) !important;
          word-wrap: break-word !important;
          overflow-wrap: break-word !important;
          hyphens: auto !important;
          flex: 1 !important;
          margin: 0 !important;
          color: #1A1A1A !important;
        `;
      });

      const accordionBodies = modal.querySelectorAll('.benefits-accordion__body');
      accordionBodies.forEach((body) => {
        body.style.cssText = `
          padding-left: 36px !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          line-height: 1.4 !important;
          width: auto !important;
          max-width: calc(100vw - 76px) !important;
          word-wrap: break-word !important;
          overflow-wrap: break-word !important;
          hyphens: auto !important;
          box-sizing: border-box !important;
          color: #777777 !important;
        `;
      });
    }

    // 确保所有子元素都可见
    const modalElements = modal.querySelectorAll('*');
    modalElements.forEach((element) => {
      element.style.visibility = 'visible !important';
      element.style.opacity = '1 !important';
      element.style.pointerEvents = 'auto !important';
    });

    // 强制禁止页面滚动
    document.body.style.overflow = 'hidden';
    document.body.style.overflowX = 'hidden';
    document.body.style.overflowY = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    document.documentElement.style.overflowY = 'hidden';

    // 阻止鼠标滚轮滚动页面
    document.addEventListener('wheel', preventPageScroll, { passive: false });
    document.addEventListener('DOMMouseScroll', preventPageScroll, { passive: false }); // Firefox兼容

    activeModalId = modalId;

    // 关闭所有手风琴项目
    const items = modal.querySelectorAll('.benefits-accordion__item');
    items.forEach((item) => {
      item.classList.remove('is-active');
    });

    // 展开指定的项目
    const activeItem = modal.querySelector(`[data-item="${activeIndex}"]`);
    if (activeItem) {
      activeItem.classList.add('is-active');
    }

    document.dispatchEvent(
      new CustomEvent('dreo:benefits-modal-open', { detail: { modalId, activeIndex } })
    );
  }

  function closeBenefitsModal(modalId) {
    modalId = modalId || activeModalId || DEFAULT_MODAL_ID;
    const modal = document.getElementById(modalId);
    if (!modal) return;

    const modalContent = modal.querySelector('.benefits-modal__content');

    modal.style.display = 'none';

    // 恢复页面滚动
    document.body.style.overflow = '';
    document.body.style.overflowX = '';
    document.body.style.overflowY = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.overflowX = '';
    document.documentElement.style.overflowY = '';

    // 移除滚轮事件监听器
    document.removeEventListener('wheel', preventPageScroll);
    document.removeEventListener('DOMMouseScroll', preventPageScroll);

    // 重置弹窗样式
    if (modalContent) {
      modalContent.style.height = '';
      modalContent.style.transition = '';
    }

    if (activeModalId === modalId) {
      activeModalId = null;
    }
    document.dispatchEvent(new CustomEvent('dreo:benefits-modal-close', { detail: { modalId } }));
  }

  // 模拟简化版的动画时间线
  function createTimeline(animations) {
    return new Promise((resolve) => {
      let completedAnimations = 0;
      const totalAnimations = animations.length;

      animations.forEach(([element, styles, options]) => {
        const duration = (options.duration || 0.25) * 1000; // 转换为毫秒
        const easing = options.easing || 'ease';
        const delay = (options.delay || 0) * 1000;

        setTimeout(() => {
          element.style.transition = `all ${duration}ms ${easing}`;

          Object.keys(styles).forEach((property) => {
            const value = Array.isArray(styles[property]) ? styles[property][1] : styles[property];

            if (property === 'height') {
              element.style.height = value;
            } else if (property === 'opacity') {
              element.style.opacity = value;
            } else if (property === 'transform') {
              element.style.transform = value;
            }
          });

          setTimeout(() => {
            completedAnimations++;
            if (completedAnimations === totalAnimations) {
              resolve();
            }
          }, duration);
        }, delay);
      });
    });
  }

  function toggleAccordionItem(index, modalId) {
    modalId = modalId || activeModalId || DEFAULT_MODAL_ID;
    const modal = document.getElementById(modalId);
    if (!modal) return;
    const clickedItem = modal.querySelector(`[data-item="${index}"]`);
    const isCurrentlyActive = clickedItem && clickedItem.classList.contains('is-active');
    const modalContent = modal.querySelector('.benefits-modal__content');

    if (!clickedItem || !modalContent) return;

    // 如果点击的是已展开的项目，关闭它
    if (isCurrentlyActive) {
      const clickedContent = clickedItem.querySelector('.benefits-accordion__content');
      const clickedBody = clickedItem.querySelector('.benefits-accordion__body');

      createTimeline([
        [clickedBody, { opacity: 0 }, { duration: 0.15 }],
        [clickedContent, { height: '0px' }, { duration: 0.25, delay: 0.05, easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)' }],
      ]).then(() => {
        clickedItem.classList.remove('is-active');
        clickedContent.style.height = '';
        clickedContent.style.transition = '';
        clickedBody.style.opacity = '';
        clickedBody.style.transition = '';
      });
      return;
    }

    // 找到当前活跃的项目
    const currentActiveItem = modal.querySelector('.benefits-accordion__item.is-active');
    const clickedContent = clickedItem.querySelector('.benefits-accordion__content');
    const clickedBody = clickedItem.querySelector('.benefits-accordion__body');

    // 计算当前展开内容的高度
    let currentContentHeight = 0;
    if (currentActiveItem) {
      const currentContent = currentActiveItem.querySelector('.benefits-accordion__content');
      if (currentContent) {
        currentContentHeight = currentContent.scrollHeight;
      }
    }

    // 计算即将展开内容的高度
    const tempItem = clickedItem.cloneNode(true);
    tempItem.classList.add('is-active');
    tempItem.style.visibility = 'hidden';
    tempItem.style.position = 'absolute';
    tempItem.style.top = '-9999px';
    tempItem.style.width = clickedItem.offsetWidth + 'px';
    document.body.appendChild(tempItem);

    const tempContent = tempItem.querySelector('.benefits-accordion__content');
    const newContentHeight = tempContent ? tempContent.scrollHeight : 0;
    document.body.removeChild(tempItem);

    // 如果高度没有变化，直接切换
    if (Math.abs(newContentHeight - currentContentHeight) < 5) {
      if (currentActiveItem) {
        currentActiveItem.classList.remove('is-active');
      }
      clickedItem.classList.add('is-active');
      return;
    }

    // 记录当前弹窗高度
    const currentModalHeight = modalContent.offsetHeight;

    // 计算高度差
    const heightDiff = newContentHeight - currentContentHeight;
    const targetModalHeight = currentModalHeight + heightDiff;

    // 暂时禁用所有自动动画
    const allContents = modal.querySelectorAll('.benefits-accordion__content');
    const allBodies = modal.querySelectorAll('.benefits-accordion__body');

    allContents.forEach((content) => {
      content.style.transition = 'none';
    });
    allBodies.forEach((body) => {
      body.style.transition = 'none';
    });

    // 设置新项目的初始状态（隐藏）
    clickedContent.style.height = '0px';
    clickedContent.style.overflow = 'hidden';
    clickedBody.style.opacity = '0';

    // 强制重绘
    modalContent.offsetHeight;

    // 固定弹窗当前高度，准备做单次过渡
    modalContent.style.height = currentModalHeight + 'px';
    modalContent.style.transition = 'height 0.25s cubic-bezier(0.4, 0.0, 0.2, 1)';

    requestAnimationFrame(() => {
      // 同时进行：弹窗高度过渡 + 收起当前项目 + 展开新项目
      modalContent.style.height = targetModalHeight + 'px';

      // 收起当前活跃项目
      if (currentActiveItem) {
        const currentContent = currentActiveItem.querySelector('.benefits-accordion__content');
        const currentBody = currentActiveItem.querySelector('.benefits-accordion__body');

        currentContent.style.transition = 'height 0.25s cubic-bezier(0.4, 0.0, 0.2, 1)';
        currentBody.style.transition = 'opacity 0.15s ease';

        currentBody.style.opacity = '0';
        currentContent.style.height = '0px';
      }

      // 同时展开新项目
      clickedContent.style.transition = 'height 0.25s cubic-bezier(0.4, 0.0, 0.2, 1)';
      clickedBody.style.transition = 'opacity 0.15s ease';

      clickedContent.style.height = newContentHeight + 'px';

      setTimeout(() => {
        clickedBody.style.opacity = '1';
      }, 100);
    });

    // 动画完成后清理并更新状态
    setTimeout(() => {
      // 更新CSS类状态
      if (currentActiveItem) {
        currentActiveItem.classList.remove('is-active');
      }
      clickedItem.classList.add('is-active');

      // 清理样式
      modalContent.style.height = '';
      modalContent.style.transition = '';
      clickedContent.style.height = '';
      clickedContent.style.transition = '';
      clickedContent.style.overflow = '';
      clickedBody.style.opacity = '';
      clickedBody.style.transition = '';

      // 清理其他项目的样式
      if (currentActiveItem) {
        const currentContent = currentActiveItem.querySelector('.benefits-accordion__content');
        const currentBody = currentActiveItem.querySelector('.benefits-accordion__body');
        currentContent.style.height = '';
        currentContent.style.transition = '';
        currentContent.style.overflow = '';
        currentBody.style.opacity = '';
        currentBody.style.transition = '';
      }

      // 恢复其他元素的transition
      allContents.forEach((content) => {
        content.style.transition = '';
      });
      allBodies.forEach((body) => {
        body.style.transition = '';
      });
    }, 300);
  }

  // 按ESC键关闭弹窗
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeModalId) {
      closeBenefitsModal(activeModalId);
    }
  });

  window.openBenefitsModal = openBenefitsModal;
  window.closeBenefitsModal = closeBenefitsModal;
  window.toggleAccordionItem = toggleAccordionItem;
  window.createBenefitsTimeline = createTimeline;
})();
